import { Button } from '@chakra-ui/react';

import { RegisterCredentials } from '../../api/types';

import schema from './schema';

import { Link } from '@/components/common/Link';
import { FieldWrapper, Form, TextInput } from '@/components/Form';
import * as LC from '@/components/LC';
import { useAuth } from '@/lib/authentication';

type RegisterFormProps = {
  onSuccess: () => void;
};

export const RegisterForm = ({ onSuccess }: RegisterFormProps) => {
  const { register, isRegistering } = useAuth();

  return (
    <Form<RegisterCredentials>
      initialValues={{
        name: '',
        email: '',
        password: '',
        confirmPassword: '',
      }}
      onSubmit={async (values) => {
        await register(values);
        onSuccess();
      }}
      validationSchema={schema}
    >
      {() => (
        <>
          <FieldWrapper
            name="name"
            required
            label="Nome"
            as={(props) => <TextInput {...props} />}
          />
          <FieldWrapper
            name="email"
            required
            label="Email"
            as={(props) => <TextInput {...props} />}
          />
          <FieldWrapper
            name="password"
            required
            label="Senha"
            as={(props) => <TextInput type="password" {...props} />}
          />
          <FieldWrapper
            name="confirmPassword"
            required
            label="Confirmar senha"
            as={(props) => <TextInput type="password" {...props} />}
          />

          <LC.Vertical center spaceBetween mt={8}>
            <Button
              isLoading={isRegistering}
              type="submit"
              className="w-full"
              variant="@primary"
              w="100%"
            >
              Cadastrar
            </Button>
            <Button as={Link} to="../entrar" variant="ghost" mt={4} size="sm">
              Voltar para login
            </Button>
          </LC.Vertical>
        </>
      )}
    </Form>
  );
};
